"use strict";

var questions = [{
  prompt: "What's the thought that you are working with?",
  extraText: "Choose a thought that isn't helping you in life. " + 'For example: "I\'ll get it wrong" or "I just got lucky", "I\'m not that talented" or "I\'m an ineffective manager". ' + 'The best thoughts to work with are thoughts that start with "I am..." or "I have to..." or "I can\'t...". ' + 'Thoughts that are predictions about the future like "If I don\'t ____, then something bad will happen" ' + "are also good to challenge.",
  placeholder: "Type your negative thought here",
  type: "multirow",
  aggregated: true
}, {
  prompt: "Why is this thought unhelpful?",
  extraText: "When you believe this thought, how does it make you feel? " + "How does it make you act? How does it make you treat yourself or treat others?",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "Why is this thought not 100% accurate?",
  extraText: "Why is this thought not 100% true in all situations at all times? " + "What is the opposite of this thought? Write down some times when the opposite of this thought was true.",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "Write down a short summary to remember this week.",
  extraText: "Please summarise what you have just written into 1 - 2 sentences. " + "Remind yourself about the summary this week whenever you can.",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "(OPTIONAL) Finding the next thought to retrain...",
  extraText: "Unhelpful thoughts occur in clusters of related thoughts that make up a belief system. " + "To identify the next thought in the cluster, " + "first: read back over the reasons why the thought is inaccurate. " + "Then ask yourself: Why does my unhelpful thought still feel true? " + "Write down any reasons you think of. These unhelpful thoughts are part of the cluster. " + "Make a note to come back and do the retraining thinking exercise with these thoughts next.",
  placeholder: "",
  type: "multirow",
  optional: true,
  aggregated: true
}];

var analysis = function analysis(answers) {
  return {
    thought: answers[0],
    whyUnhelpful: answers[1],
    whyInaccurate: answers[2],
    summary: answers[3],
    nextThought: answers[4]
  };
};

module.exports = {
  questions: questions,
  analysis: analysis
};